var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#B6D6E9;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#6DCAF3;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:10.9562px;}\n\t.st6{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.36,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.06,148.54,63.67,182.83,106.36,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 47.63,
    className: "st1",
    width: 19.37,
    height: 7.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 72.1,
    className: "st1",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "116.07,54.74 96.68,54.66 95.89,72.11 136.17,72.11  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.54,
    y: 72.1,
    className: "st2",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "96.68,54.66 76.54,72.11 116.83,72.11  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.95,148.03H88.81c-4.34,0-7.85-3.52-7.85-7.85V91.76c0-4.34,3.52-7.85,7.85-7.85h16.15 c4.34,0,7.85,3.52,7.85,7.85v48.41C112.8,144.52,109.29,148.03,104.95,148.03z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 87.3063 134.7681)",
    className: "st2 st4 st5"
  }, "Milk")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.41,96.16c0.55,0.77,1.1,1.51,1.63,2.27c1.58,2.26,3.04,4.59,4.3,7.04c0.8,1.57,1.52,3.17,2.04,4.86 c0.26,0.85,0.47,1.72,0.55,2.61c0.17,1.83-0.17,3.56-1.1,5.14c-1.33,2.26-3.3,3.67-5.88,4.16c-4.47,0.85-8.89-2.07-9.89-6.51 c-0.31-1.38-0.26-2.76,0.05-4.13c0.39-1.75,1.05-3.41,1.82-5.02c1.29-2.71,2.86-5.26,4.56-7.73c0.6-0.86,1.22-1.71,1.84-2.56 C97.34,96.25,97.36,96.22,97.41,96.16z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/Milk.002a134e1b6341b9804ed47be6674d7e.svg";
export { ForwardRef as ReactComponent };